import $ from 'jquery';
// eslint-disable-next-line import-x/no-unassigned-import
import 'jquery-validation';
import validationOptions from './validation-options';

// Handle form validation.
if ($('form').length > 0) {
	$('form').validate(validationOptions);
}
